import { t } from '@lingui/macro';
import { DinteroErrorTypes } from './types';

export function getErrorTextBasedOnErrorType(error: DinteroErrorTypes) {
  switch (error) {
    case 'cancelled':
      return t`Payment cancelled`;
    case 'authorization':
    case 'failed':
    case 'capture':
      return t`Payment failed`;
    default:
      return t`Payment failed`;
  }
}
